import React from 'react'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'

import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

import Container from 'Container'
import { appName, primaryColor } from './Styles'

import { ColorsProvider } from './context/ColorsProvider'

const theme = createMuiTheme({
  props: {
    MuiButtonBase: {
      disableRipple: true,
    }
  },
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      // main: '#AAD284'
      main: '#FFF',
    },
  },
})

class App extends React.Component {
  render() {
    document.title = appName
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <MuiThemeProvider theme={theme}>
          <ColorsProvider>
            <Container />
          </ColorsProvider>
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js